import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DynamicIconDirective } from '@shared/src/lib/directives/dynamic-icon.directive';
import { UserPanel } from './user-panel.interface';
import { UserProfile } from '@shared/src/models/user-profile';

@Component({
  selector: 'lib-user-panel',
  standalone: true,
  imports: [CommonModule, DynamicIconDirective],
  templateUrl: './user-panel.component.html',
  styleUrl: './user-panel.component.css',
})
export class UserPanelComponent {
  @Input() dropdownItems: UserPanel[] = [];
  @Input() user: UserProfile;
}
